<template>
  <section v-if="error">
    <br/>
    <p class="error">{{ error }}</p>
  </section>

 <section class="grid-container" v-if="!error && loaded && task && task.taskStatus !== TASK_STATUS.SUCCESSFULLY_COMPLETED.value">
    <div>
      <br/>
        <WizardProgress :currentStep="stepIndex + 1" :totalSteps="steps.length" />
    </div>
    <div class="page-container grid-container wizard">
      <div class="grid-x grid-margin-x" >
        <component v-if="loaded" :key="stepIndex" :is="currentStepComponent" @next="nextStep" @prev="prevStep" ref="stepComponentRef" :formData="formData" @update-form="handleFormUpdate"/>

        <div v-if="stepIndex < steps.length - 1" id="wizard-navigation" class="cell small-12">
          <button class="btn btn-secondary" @click="prevStep" v-if="stepIndex != 0" :disabled="isProcessing">Previous</button>
          <button class="btn btn-primary" @click="nextStep" :disabled="isProcessing || stepIndex === steps.length - 1">{{ isProcessing ? 'Please wait...' : 'Next' }}</button>
          <button class="btn btn-link" @click="finish" :disabled="isProcessing">Cancel</button>
        </div>

        <div class="cell small-12">
          <button class="btn btn-primary" @click="finish" v-if="stepIndex == steps.length - 1">Finish</button>
        </div>


      </div>
    </div>

  </section>

    <section class="page-container grid-container" v-else> 
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <a @click="router.back()">← Back</a>
        </div>
    </div>
    <br/>
    <div class="grid-x grid-margin-x">
        <div class="cell small-12">
            <h1 class="text-2xl font-bold">Benefit in Kind Questionnaire</h1>
            <p>Thank you for completing your benefit in kind questionnaire, it is currently being reviewed by our team.</p>
            <table v-if="questionnaireResponse">
            <thead>
              <tr>
                <th>Benefits in Use</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in questionnaireResponse" :key="key">
                <td>{{ formatBenefitKey(key) }}</td>
              </tr>
            </tbody>
          </table>
                    <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
        </div>


    </div>
  </section>

</template>


<script setup>

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import WizardProgress from '@/components/navigation/WizardProgressBar.vue';
import Step1 from './BIK-Questionnaire-Step1.vue'
import Step2 from './BIK-Questionnaire-Step2.vue'
import Step3 from './BIK-Questionnaire-Step3.vue'




const steps = [
  { label: 'Getting Started', component: Step1 },
  { label: 'Benefits in Use', component: Step2 },
  { label: 'Complete', component: Step3 },

];
const stepIndex = ref(0)

const loaded = ref(false);

const stepComponentRef = ref(null)
const isProcessing = ref(false)

const currentStepComponent = computed(() => steps[stepIndex.value].component)

const route = useRoute();
const router = useRouter();
const taskId = route.params.taskId;
const task = ref(null);
const questionnaireResponse = ref(null);

import { TASK_STATUS } from '@/helpers/constants';

import { getDataCollectionTask } from '@/services/implementationmanagement.api';
onMounted(async () => {

  var response = await getDataCollectionTask(taskId);

  if(response.status !== 200 || response.data === null || response.data === undefined) {
    error.value = errorString;
    return null;
  }

  task.value = response.data;

   try {

    // If dataJson is empty string then set accoridingly, otherwise parse it
    if(!task.value.dataJson || task.value.dataJson.trim() === "") {
      questionnaireResponse.value = "";
      loaded.value = true;
      return;
    }

    questionnaireResponse.value = JSON.parse(task.value.dataJson);

    loaded.value = true;
  } catch (e) {
    error.value = "Failed to parse questionnaire data";
    return;
  }

});

/**
 * Array of skip rules for wizard steps.
 * Each rule: { from: stepIndex, direction: 1|-1, condition: (formData) => boolean, to: stepIndex }
 */
const stepSkipRules = [
  {
    from: 2, // Step 3 (0-based)
    direction: 1,
    condition: (data) => data.companyIsContractor === 'false',
    to: 4 // Skip to step 5
  },
  {
    from: 4, // Step 5 (0-based), going back
    direction: -1,
    condition: (data) => data.companyIsContractor === 'false',
    to: 2 // Skip back to step 3
  }
];

const HandleConditionalStepSkipping = (direction = 1) => {
  const current = stepIndex.value;

  const rule = stepSkipRules.find(
    r => r.from === current && r.direction === direction && r.condition(formData.value)
  );
  if (rule) {

    stepIndex.value = rule.to;
    return true;
  }
  return false;
};

const nextStep = async () => {
  if (isProcessing.value) return;

  isProcessing.value = true;

  try {
    if (stepComponentRef.value && typeof stepComponentRef.value.validateStep === 'function') {
      const isValid = stepComponentRef.value.validateStep();

      if (!isValid) {
        return;
      }
    }

    if (stepComponentRef.value && typeof stepComponentRef.value.executeStep === 'function') {
      const success = await stepComponentRef.value.executeStep();
      if (!success) return;
    }

    error.value = null; // clear previous errors

    if (!HandleConditionalStepSkipping(1)) {
      if (stepIndex.value < steps.length - 1) {
        stepIndex.value++;
      }
    }
  } finally {
    isProcessing.value = false;
  }
};

const prevStep = () => {
  if (isProcessing.value) return;

  if (!HandleConditionalStepSkipping(-1)) {
    if (stepIndex.value > 0) {
      stepIndex.value--;
    }
  }
};



const finish = () => {
  if (isProcessing.value) return;

  router.back();
}

const error = ref(null)


const formData = ref({
});
const handleFormUpdate = (updatedData) => {
  formData.value = updatedData;
};


const formatBenefitKey = computed(() => (str) => {
  if (!str) return '';
  let s = str;
  if (s.startsWith('has')) {
    s = s.slice(3);
  }
  s = s.replace(/([A-Z])/g, ' $1').trim();
  s = s.replace(/\bAnd\b/, 'and');
  s = s.replace(/\bOr\b/, 'or');
  return s;
});


</script>


<style scoped>
#wizard-breadcrumbs {
  margin-bottom: 40px;
  margin-top: 40px;
}

#wizard-navigation
{
  margin-top:30px;
}

</style>